import axios from "axios";

export const getPromo = async (data) => {
  const { data: response } = await axios.get(
    `https://aaa-prisma.herokuapp.com/api/promo/get/${data}`
  );
  return response;
};

export const editPromo = async (data) => {
  const { data: response } = await axios.post(
    "https://aaa-prisma.herokuapp.com/api/promo/edit",
    data.variables
  );
  return response;
};

export const getClicks = async (data) => {
  const { data: response } = await axios.get(
    "https://aaa-prisma.herokuapp.com/api/promo/clicks",
    data
  );
  return response;
};

export const newClick = async (data) => {
  const { data: response } = await axios.post(
    "https://aaa-prisma.herokuapp.com/api/promo/click",
    data.variables
  );
  return response;
};
